
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68 68"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('mask',{attrs:{"id":"a","x":"0","y":"0","width":"68","height":"68","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M3 3h62v62H3z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"34","cy":"34","r":"31"}})]),_c('mask',{attrs:{"id":"b","x":"3","y":"3","width":"62","height":"62","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M3 3h62v62H3z"}}),_c('circle',{staticClass:"a",attrs:{"cx":"34","cy":"34","r":"28"}})])]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('circle',{attrs:{"cx":"34","cy":"34","r":"31","fill":"#c49065"}}),_c('circle',{attrs:{"cx":"34","cy":"34","r":"31","stroke":"#a4734b","stroke-width":"6","fill-opacity":"0"}})]),_c('g',{attrs:{"mask":"url(#b)"}},[_c('path',{attrs:{"d":"M49.5 17L62 48l-4 4-12 8.5L34.5 63 23 61l-2.5-9.5L38 52l12-7z","fill-rule":"evenodd","fill":"#b7855c"}})]),_c('path',{staticClass:"g",attrs:{"d":"M37.45 51.44l-15-.09A2.48 2.48 0 0120 48.88V19.47A2.47 2.47 0 0122.47 17h24.76a2.46 2.46 0 012.46 2.47v24.71L41 43.56a2 2 0 00-2.1 1.55zM50 44.5l-12.5 7"}}),_c('path',{attrs:{"d":"M35.13 24.87v7.2h7.12v2.1h-7.12v7.2h-2.26v-7.2h-7.12v-2.1h7.12v-7.2z","fill":"#5e3717"}})])
          )
        }
      }
    